import { FC } from 'react';

import { Image } from '../Image';

interface Props {
  artists: StoryblokImage[];
}

const Row = ({ images }: { images: StoryblokImage[] }) => (
  <div className="flex grow gap-3">
    {images.map((image) => (
      <figure key={image.id} className="w-20 shrink-0 md:w-44">
        <Image
          alt={image.alt}
          shape="circle"
          src={image.filename}
          width={128}
        />
      </figure>
    ))}
  </div>
);

export const ArtistsGroup: FC<Props> = ({ artists }) => (
  <section className="flex w-full flex-col items-center overflow-hidden">
    <Row images={artists.slice(0, 11)} />
    <Row images={artists.slice(11)} />
  </section>
);
